
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminPanel from './components/AdminPanel';
import { ContentProvider } from './services/contentService';
import { initializeLTISession } from './services/ltiSession';
import SessionGuard from './components/SessionGuard';

// Captura el ?session=<JWT> emitido por el servicio LTI antes de renderizar
// nada. Se hace aqui (no en App.jsx) para que la URL ya este limpia cuando
// react-router-dom lea location.search en el primer render.
initializeLTISession();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ContentProvider>
        <Routes>
          <Route path="/" element={<SessionGuard><App /></SessionGuard>} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ContentProvider>
    </BrowserRouter>
  </React.StrictMode>
);
